import React from "react";
import { Flex } from "theme-ui";
import { NavWrapper, NavItem } from "./styled";
import { OverviewIcon, NotesIcon, PhotosIcon } from "components/svg";
import { themevals } from "theme/themevals";

export const NAV_ITEMS = ["Overview", "Notes", "Photos"] as const;
export type DispatchNavItem = typeof NAV_ITEMS[number];

const ICONS = {
  Overview: OverviewIcon,
  Notes: NotesIcon,
  Photos: PhotosIcon,
} as const;

type DispatchNavProps = {
  activeItem: DispatchNavItem;
  onSelect: (item: DispatchNavItem) => void;
  notesCount?: number;
};

const DispatchNav: React.FC<DispatchNavProps> = ({ activeItem, onSelect, notesCount = 0 }) => {
  return (
    <NavWrapper>
      {NAV_ITEMS.map((item) => (
        <NavItem key={item} active={activeItem === item} onClick={() => onSelect(item)}>
          <Flex sx={{ alignItems: "center", gap: "6px" }}>
            {React.createElement(ICONS[item], {
              width: "16px",
              height: "16px",
              fill: activeItem === item ? "#fff" : themevals.colors.dkgrey,
            })}
            <span>{item === "Notes" ? `Notes (${notesCount})` : item}</span>
          </Flex>
        </NavItem>
      ))}
    </NavWrapper>
  );
};

export default DispatchNav;
